import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PaginatedPhysicalDock } from 'contracts/PhysicalDocks';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  { prefix: 'PAGINATE_PHYSICAL_DOCKS_' }
);

export interface PaginatePhysicalDocksState {
  data: PaginatedPhysicalDock[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginatePhysicalDocksRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedPhysicalDock[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginatePhysicalDocksState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginatePhysicalDocksState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginatePhysicalDocksState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginatePhysicalDocksState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginatePhysicalDocksState) =>
  update(state, { loading: { $set: false } });

const reset = () => INITIAL_STATE;

export const paginatePhysicalDocks = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginatePhysicalDocksTypes = Types;
export const PaginatePhysicalDocksActions = Creators;
